import * as React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */ "@/components/BannerSlider/bannerSlider.container"
    ).then((module) => ({ default: module.BannerSlider }))
);
